function TermsConditions() {
  return (
    <main className='px-6 py-12'>
      <div className='mx-auto max-w-[800px]'>
        <h1 className='mb-6 pb-4 text-center text-2xl font-bold'>
          紀陽ＤＸプラットフォーム（Ｋｅｙ{'　'}Ｘ）共通利用規約
        </h1>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第１条（適用）</h2>
          <p className='mb-4'>
            本規約は、株式会社紀陽銀行（以下「当行」といいます。）が提供する「紀陽ＤＸプラットフォーム（Ｋｅｙ{'　'}Ｘ）」（以下「本サービス」といいます。）の利用条件を定めるものです。
          </p>
          <p className='mb-4'>
            本サービスを利用するすべての個人および法人（以下「利用者」といいます。）に適用されます。
          </p>
          <p className='mb-4'>
            利用者は、本規約の内容を理解し、同意した上で本サービスを利用するものとします。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第２条（定義）</h2>
          <p className='mb-2'>
            本規約において使用する以下の用語は、各々以下に定める意味を有するものとします。
          </p>
          <ol className='mb-4 list-decimal pl-6'>
            <li className='mb-2'>
              「本サービス」とは、別紙に定める当行が提供する「紀陽ＤＸプラットフォーム（Ｋｅｙ{'　'}Ｘ）」という名称のサービスを意味します。（理由の如何を問わずサービスの名称又は内容が変更された場合は、当該変更後のサービスを含みます。）
            </li>
            <li className='mb-2'>
              「利用者」とは、本サービスを利用するすべての個人および法人をいいます。
            </li>
            <li className='mb-2'>
              「投稿情報」とは、利用者が本サービス上で投稿・送信・登録する一切の情報をいいます。
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第３条（サービス内容の変更）</h2>
          <p className='mb-4'>
            当行は利用者への事前通知なく、本サービスの内容の全部または一部を変更することができます。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第４条（禁止事項）</h2>
          <p className='mb-2'>
            利用者は、本サービスの利用にあたり、以下の行為を禁止します。以下の行為をおこなう利用者については、当行から本サービスの利用をお断りすることがあります。
          </p>
          <ul className='mb-4 list-disc pl-6'>
            <li>法令または公序良俗に違反する行為</li>
            <li>第三者の権利を侵害する行為</li>
            <li>本サービスの他の利用者又は第三者に不利益、損害又は不快感を与える行為</li>
            <li>誹謗中傷または名誉毀損に該当する行為</li>
            <li>個人情報の不正な共有・取得</li>
            <li>なりすまし行為</li>
            <li>無断広告や営業活動</li>
            <li>本サービスの運営を妨害する行為</li>
            <li>虚偽又は誤解を招くような内容を含む情報等を、掲載等し又は登録する行為</li>
            <li>地域課題解決に明らかに関係のない目的をもって行われたものと当行が判断した行為</li>
            <li>その他、当行が不適切と判断した行為</li>
          </ul>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第５条（投稿情報）</h2>
          <p className='mb-2'>利用者は、投稿情報について一切の責任を負います。</p>
          <p className='mb-4'>
            当行は、利用者が前条に違反した場合、投稿削除や利用停止等の措置を講じることができます。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第６条（個人情報の取扱い）</h2>
          <p className='mb-4'>
            当行は、利用者の個人情報を法令および当行のプライバシーポリシーに従い適切に管理・利用します。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第７条（サービスの停止・中断）</h2>
          <ol className='mb-4 list-decimal pl-6'>
            <li className='mb-2'>
              当行は、当行が必要と判断した場合はいつでも、本サービスの全部または一部を停止または中断することができます。
            </li>
            <li className='mb-2'>
              当行は、前項による本サービスの停止または中断によって利用者に生じた損害について、一切責任を負いません。
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第８条（免責事項）</h2>
          <p className='mb-2'>
            当行は、本サービスの正確性、完全性、有用性等について保証するものではありません。
          </p>
          <p className='mb-4'>
            当行は、当行に故意または重過失がある場合を除き、本サービスの利用により利用者及び第三者に生じた損害について責任を負いません。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第９条（サービスの終了）</h2>
          <ol className='mb-4 list-decimal pl-6'>
            <li className='mb-2'>
              当行は、当行の裁量により、本サービスを終了することができます。
              <br />
              この場合、当行は事前に利用者へ本サービスが終了する旨を告知します。
            </li>
            <li className='mb-2'>
              当行は、前項による本サービスの終了によって利用者に生じた損害について、一切責任を負いません。
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第１０条（規約の変更）</h2>
          <p className='mb-2'>当行は、利用者の承諾を得ることなく、本規約を変更することができます。</p>
          <p className='mb-4'>
            この変更を行う場合、当行は、本規約を変更する旨及び変更後の規約の内容並びに効力発生時期を、当行所定の方法（当行ホームページへの掲載等）により周知します。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第１１条（損害賠償）</h2>
          <p className='mb-4'>
            利用者が本規約に違反し、当行または第三者に損害を与えた場合、当該利用者はその損害を賠償する責任を負います。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第１２条（反社会的勢力の排除）</h2>
          <ol className='mb-4 list-decimal pl-6'>
            <li className='mb-2'>
              利用者は、現在および将来にわたり、自己および自己の役員等が反社会的勢力（暴力団、暴力団員、暴力団関係企業、総会屋その他暴力、威力、詐欺的手法を利用して経済的利益を追求する者をいいます。）及びこれらに準ずる者に該当せず、またこれらと関係を有しないことを表明し、保証するものとします。
            </li>
            <li className='mb-2'>
              利用者は、自らまたは第三者を利用して、暴力的または不当な要求行為その他これに準ずる行為を行わないものとします。
            </li>
            <li className='mb-2'>
              当行は、利用者が前二項に違反したと認めた場合、何らの通知または催告を要することなく、本サービスの利用停止または利用契約の解除を行うことができます。
            </li>
            <li className='mb-2'>
              前項の措置により利用者に損害が生じても、当行は責任を負わないものとします。
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第１３条（準拠法および管轄）</h2>
          <p className='mb-2'>本規約は日本法を準拠法とします。</p>
          <p className='mb-4'>
            本サービスに関して生じた紛争については、当行の本店所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。
          </p>
        </section>

        <p className='mb-12'>以上</p>

        <section className='mb-8 pt-8'>
          <h2 className='mb-4 text-center text-xl font-semibold'>
            ＜別紙＞{'　'}本サービス「紀陽ＤＸプラットフォーム（Ｋｅｙ{'　'}Ｘ）」について
          </h2>
          <p className='mb-4'>
            第２条に定める本サービスは、以下の通りで、すべて無料でご利用いただけます。
          </p>

          <section className='mb-6'>
            <h3 className='mb-2 text-lg font-semibold'>１.オウンドメディア</h3>
            <p className='mb-4'>
              当行が提供するＤＸに関する記事、インタビューなどの情報コンテンツを閲覧できます。ＤＸに関する最新動向や成功事例を掲載し、利用者のＤＸ推進に役立つ情報を提供します。
            </p>
          </section>

          <section className='mb-6'>
            <h3 className='mb-2 text-lg font-semibold'>２.イベント情報</h3>
            <p className='mb-4'>
              当行や自治体等が主催・協賛するＤＸ関連イベントの概要ページを閲覧できます。イベントの詳細や申し込み方法について情報を提供し、利用者が参加できる機会を案内します。
            </p>
          </section>

          <section className='mb-6'>
            <h3 className='mb-2 text-lg font-semibold'>３.支援サービス情報</h3>
            <p className='mb-4'>
              当行や自治体等が提供するＤＸ関連支援サービスの概要や紹介ページを閲覧できます。ＤＸ推進に役立つ各種支援メニューを紹介します。
            </p>
          </section>

          <section className='mb-6'>
            <h3 className='mb-2 text-lg font-semibold'>４.ＤＸ診断</h3>
            <p className='mb-4'>
              ＤＸの進捗状況を把握するための診断ツールを提供します。利用者が回答を入力することで、ＤＸ推進の現状を分析し、具体的な支援メニューを提案します。
            </p>
          </section>

          <section className='mb-6'>
            <h3 className='mb-2 text-lg font-semibold'>５.オンラインコミュニティ</h3>
            <p className='mb-4'>
              ＤＸ推進を目的としたオンラインコミュニティを提供します。ＤＸに関する意見交換やノウハウ共有の場として、企業同士や当行と情報交換ができる場を提供します。
            </p>
          </section>
        </section>
      </div>
    </main>
  );
}

export default TermsConditions;
